<template>
  <v-app class="ma-12 pa-12">
    <div>
      <nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom">
        <div class="container">
          <a class="navbar-brand" href="/">
            <img
              src="././assets/images/skala-logo-sem-bg.png"
              width="140"
              loading="lazy"
              alt="Skala Logo"
            />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbar-menu-content"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span>
              <img src="./assets/images/barras.png" alt="barras" width="40" />
            </span>
          </button>
          <div
            class="navbar-collapse collapse justify-content-end"
            id="navbar-menu-content"
          >
            <ul class="navbar-nav d-flex justify-content-end">
              <li
                class="nav-item"
                v-for="item in paginas"
                :key="item.title"
                link
                @click="trocarTela"
              >
                <a>
                  <router-link
                    tag="li"
                    class="col nav-link text-blue"
                    :to="item.link"
                    >{{ item.title }}</router-link
                  >
                </a>
              </li>
              <li>
                <a v-if="!auth">
                  <router-link
                    tag="li"
                    class="col nav-link text-blue"
                    :to="'/login'"
                    >LOGAR</router-link
                  >
                </a>
              </li>
              <li class="nav-item dropdown" v-if="auth">
                <a
                  class="nav-link dropdown-toggle text-blue"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  >SISTEMA NOTICIAS</a
                >
                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <a
                    v-for="item in items"
                    :key="item.title"
                    link
                    @click="trocarTela"
                  >
                    <div
                      class="dropdown-divider"
                      v-if="item.title == 'Sair'"
                    ></div>
                    <router-link
                      tag="li"
                      class="dropdown-item"
                      :to="item.link"
                      >{{ item.title }}</router-link
                    >
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>

    <div class="row vw-100 m-0">
      <div
        class="container-fluid p-0"
        v-if="['Inicio'].indexOf($route.name) > -1"
      >
        <router-view></router-view>
      </div>
      <v-container v-else>
        <router-view></router-view>
      </v-container>
    </div>
    <div>
      <footer class="bg-blue py-4">
        <div class="container">
          <div class="row">
            <div class="row text-white">
              <div class="col-md-6 text-center text-md-left">
                <p>
                  © {{ new Date().getFullYear() }} Skala - Todos os direitos
                  reservados
                </p>
              </div>
              <div
                class="
                  col-md-6
                  d-flex
                  justify-content-center justify-content-md-end
                "
              >
                <h5>Nos siga nas redes sociais:</h5>
                <a
                  class="ml-2 mr-2"
                  href="https://www.facebook.com/Skala.contabilidade.Ltda/"
                  target="_blank"
                  style="color: white"
                >
                  <img
                    src="./assets/images/facebook.png"
                    alt="Facebook"
                    width="40"
                  />
                </a>
                <a
                  href="https://www.instagram.com/skala_cont/"
                  target="_blank"
                  style="color: white"
                >
                  <img
                    src="./assets/images/instagram.png"
                    alt="Instagram"
                    width="40"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <div>
      <a
        href="https://wa.me/551138545377?text=Ola%20poderia%20me%20ajudar"
        target="_blank"
      >
        <img
          class="whatsapp"
          src="https://images.tcdn.com.br/static_inst/integracao/imagens/whatsapp.png"
          alt="WhatsApp"
        />
      </a>
    </div>
  </v-app>
</template>

<script>
/* eslint-disable */
import EventBus from "./components/EventBus";
import axios from "axios";
import router from "./router";

export default {
  name: "App",
  data() {
    const token = localStorage.usertoken;
    return {
      auth: "",
      token: token,
      paginas: [
        {
          title: "INÍCIO",
          link: "/inicio",
        },
        {
          title: "PARCEIROS",
          link: "/parceiros",
        },
        {
          title: "SERVIÇOS",
          link: "/servicos",
        },
        {
          title: "NOTÍCIAS",
          link: "/noticias",
        },
        {
          title: "ORÇAMENTO",
          link: "/orcamento",
        },
        {
          title: "ÁREA DO CLIENTE",
          link: "/cliente",
        },
      ],
      items: [
        { title: "Tutorial", link: "/tutorial" },
        {
          title: "Listar Notícias",
          link: "/listar",
        },
        {
          title: "Cadastrar Usuário",
          link: "/registrar",
        },
        { title: "Sair", link: "/sair" },
        // { title: "Registrar", icon: "mdi-account" },
      ],
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("usertoken");
      router.push({ name: "Login" }).catch(() => {});
      this.emitMethod();
    },
    trocarTela(e) {
      if (e.target.textContent == "Tutorial")
        router.push({ name: "Tutorial" }).catch(() => {});
      else if (e.target.textContent == "Listar Notícias")
        router.push({ name: "ListarPosts" }).catch(() => {});
      else if (e.target.textContent == "Cadastrar Usuário")
        router.push({ name: "Registrar" }).catch(() => {});
      else if (e.target.textContent == "Sair") this.logout();
    },
    getUsuario() {
      axios
        .get("https://www.sabios.net.br/api/usuario/perfil", {
          headers: { Authorization: this.token },
        })
        .then((res) => {
          if (!res.data.toString().match("expired")) {
            this.auth = localStorage.getItem("usertoken") ? "ok" : "";
          } else {
            this.emitMethod();
            if (["noticia", "noticias"].indexOf(this.$route.name) > -1)
              router.push({ name: "Login" }).catch(() => {});
          }
        })
        .catch((err) => {
          console.log(err);
          if (["noticia", "noticias"].indexOf(this.$route.name) > -1)
            router.push({ name: "Login" }).catch(() => {});
        });
    },
    emitMethod() {
      EventBus.$emit("logged-in", "");
    },
  },
  mounted() {
    if (
      [
        "Tutorial",
        "ListarPosts",
        "CriarPosts",
        "EditarPosts",
        "Registrar",
      ].indexOf(this.$route.name) > -1
    )
      this.getUsuario();
    EventBus.$on("logged-in", (status) => {
      this.auth = localStorage.getItem("usertoken") ? status : "";
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue